"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _chunkB2edacfb = require("./chunk-b2edacfb.js");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = (0, _chunkB2edacfb.a)(["\n  box-sizing: border-box;\n  padding: 6px;\n  border: 1px solid\n    ", ";\n  border-radius: 4px;\n  min-height: 20px;\n  font-size: 14px;\n  font-family: ", ";\n  transition: border 0.1s;\n\n  &::placeholder {\n    color: ", ";\n    font-style: italic;\n  }\n\n  &:focus {\n    border: 1px solid\n      ", ";\n    outline: none;\n    transition: border 0.1s;\n  }\n  &:not(.regex-input) {\n    font-family: ", ";\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n    color: rgba(0, 0, 0, 0.38);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Input = _styledComponents.default.input.withConfig({
  displayName: "Input",
  componentId: "sc-127gx9d-0"
})(_templateObject(), function (props) {
  return props.invalid ? props.theme["$brand-danger-dark"] : props.theme["$gray-10"];
}, function (props) {
  return props.theme["$font-body"];
}, function (props) {
  return props.theme["$gray-30"];
}, function (props) {
  return props.invalid ? props.theme["$brand-danger-dark"] : props.theme["$brand-primary"];
}, function (props) {
  return props.theme["$font-body"];
});

var _default = Input;
exports.default = _default;